<script>
import MetisMenu from "metismenujs/dist/metismenujs";

export default {
    data() {
        return {
            mostrarPagos: false
        };
    },
    computed: {
        puedeVerProyeccion() {
            const permission = document.querySelector('meta[name="enrollment-projection-preview"]');
            return !!permission && permission.content === '1';
        },
        isAdmin() {
            return this.user.rol === 'SuperAdmin' || this.user.rol === 'Admin';
        },
        puedeVerAnalisis() {
            return this.isAdmin || String(this.user && this.user.id ? this.user.id : '') === '2';
        },
        puedeVerDashboardAdmision() {
            return ['SuperAdmin', 'Admin'].includes(this.user.rol);
        },
        puedeVerMetricasHubSpot() {
            return ['SuperAdmin', 'Admin', 'Director'].includes(this.user.rol);
        },
        puedeVerArancelesHubSpot() {
            return this.hasRestrictedAccess;
        },
        puedeVerViaAdmision() {
            return this.isAdmin || this.user.rol === 'Director';
        },
        puedeVerCertificadoTitulo() {
            return this.isAdmin || ['11', '41'].includes(String(this.user && this.user.id ? this.user.id : ''));
        },
        puedeVerEventos() {
            return !['Laborante', 'Director'].includes(this.user.rol);
        },
        puedeCrearEventos() {
            return ['SuperAdmin', 'Admin', 'Supervisor', 'Coordinador'].includes(this.user.rol);
        },
        puedeVerColegios() {
            return !['Laborante', 'Decana', 'Gastos', 'Director'].includes(this.user.rol);
        },
        puedeCrearColegios() {
            return ['SuperAdmin', 'Admin', 'Supervisor', 'Coordinador'].includes(this.user.rol);
        },
        puedeVerGastos() {
            return this.isAdmin || this.user.rol === 'Coordinador' || this.user.rol === 'Gastos';
        },
        puedeVerLaborantes() {
            return this.isStaff || this.user.rol === 'Coordinador' || this.esUsuarioPermisoEspecialLaborantes || this.user.rol === 'Gastos';
        },
        puedeVerPagosLaborantes() {
            return this.isAdmin || this.user.rol === 'Coordinador' || this.user.rol === 'Gastos';
        },
        isStaff() {
            return ['SuperAdmin', 'Admin', 'Supervisor'].includes(this.user.rol);
        },
        esUsuarioPermisoEspecialLaborantes() {
            return String(this.user && this.user.id ? this.user.id : '') === '4';
        },
        esDigitalizadorSoloHistorial() {
            return [
                'barbara.galdames@ugm.cl',
                'catalina.guajardo@estudiante.ugm.cl',
                'maria.castillo@estudiante.ugm.cl'
            ].includes(String(this.user && this.user.email ? this.user.email : '').trim().toLowerCase());
        }
    },
    components: {},
    mounted: function () {
        const sidebarLayout = localStorage.getItem('sidebar-layout');
        switch (sidebarLayout) {
            case 'light-sidebar':
                this.lightSidebar();
                break;
            case 'compact-sidebar':
                this.compactSidebar();
                break;
            case 'icon-sidebar':
                this.iconSidebar();
                break;
            case 'colored-sidebar':
                this.coloredSidebar();
                break;
            case 'boxed-layout':
                this.boxedLayout();
                break;
            default:
                document.body.setAttribute("data-sidebar", "dark");
                break;
        }
        // eslint-disable-next-line no-unused-vars
        var menuRef = new MetisMenu("#side-menu");
        var links = document.getElementsByClassName("side-nav-link-ref");
        var matchingMenuItem = null;
        for (var i = 0; i < links.length; i++) {
            if (window.location.pathname === links[i].pathname) {
                matchingMenuItem = links[i];
                break;
            }
        }

        if (matchingMenuItem) {
            matchingMenuItem.classList.add("active");
            var parent = matchingMenuItem.parentElement;

            /**
             * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
             * We should come up with non hard coded approach
             */
            if (parent) {
                parent.classList.add("mm-active");
                const parent2 = parent.parentElement.closest("ul");
                if (parent2 && parent2.id !== "side-menu") {
                    parent2.classList.add("mm-show");

                    const parent3 = parent2.parentElement;
                    if (parent3) {
                        parent3.classList.add("mm-active");
                        var childAnchor = parent3.querySelector(".has-arrow");
                        var childDropdown = parent3.querySelector(".has-dropdown");
                        if (childAnchor) childAnchor.classList.add("mm-active");
                        if (childDropdown) childDropdown.classList.add("mm-active");

                        const parent4 = parent3.parentElement;
                        if (parent4) parent4.classList.add("mm-show");
                        const parent5 = parent4.parentElement;
                        if (parent5) parent5.classList.add("mm-active");
                    }
                }
            }
        }
    },
    created() {
        axios.get('/api/config').then(response => {
            this.mostrarPagos = response.data.mostrarPagos;
        });
    },
    methods: {
        defaultSidebar() {
            localStorage.setItem("sidebar-layout", 'default-sidebar');
            document.body.setAttribute("data-sidebar", "dark");
            document.body.removeAttribute("data-layout-size", "boxed");
            document.body.removeAttribute("data-sidebar-size", "small");
            document.body.removeAttribute("data-topbar", "small");
            document.body.classList.remove("vertical-collpsed");
        },
        lightSidebar() {
            localStorage.setItem("sidebar-layout", 'light-sidebar');
            document.body.setAttribute("data-topbar", "dark");
            document.body.removeAttribute("data-sidebar");
            document.body.removeAttribute("data-layout-size", "boxed");
            document.body.removeAttribute("data-sidebar-size", "small");
            document.body.classList.remove("vertical-collpsed");
        },
        compactSidebar() {
            localStorage.setItem("sidebar-layout", 'compact-sidebar');
            document.body.setAttribute("data-sidebar-size", "small");
            document.body.setAttribute("data-sidebar", "dark");
            document.body.removeAttribute("data-layout-size", "boxed");
            document.body.classList.remove("vertical-collpsed");
            document.body.removeAttribute("data-topbar", "dark");
        },
        iconSidebar() {
            localStorage.setItem("sidebar-layout", 'icon-sidebar');
            document.body.setAttribute("data-keep-enlarged", "true");
            document.body.classList.add("vertical-collpsed");
            document.body.setAttribute("data-sidebar", "dark");
            document.body.removeAttribute("data-topbar", "dark");
            document.body.removeAttribute("data-layout-size", "boxed");
        },
        boxedLayout() {
            localStorage.setItem("sidebar-layout", 'boxed-layout');
            document.body.setAttribute("data-keep-enlarged", "true");
            document.body.classList.add("vertical-collpsed");
            document.body.setAttribute("data-layout-size", "boxed");
            document.body.removeAttribute("data-sidebar", "colored");
            document.body.setAttribute("data-sidebar", "dark");
            document.body.removeAttribute("data-topbar", "dark");
        },
        coloredSidebar() {
            localStorage.setItem("sidebar-layout", 'colored-sidebar');
            document.body.setAttribute("data-sidebar", "colored");
            document.body.removeAttribute("data-layout-size", "boxed");
            document.body.removeAttribute("data-sidebar-size", "small");
            document.body.classList.remove("vertical-collpsed");
        },
        crear(tipo){
            localStorage.setItem("usuario", tipo);
            window.location.href = "/web/configuracion/crearusuario";
        }
    }
};
</script>

<template>
<!-- ========== Left Sidebar Start ========== -->

<!--- Sidemenu -->
<div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
        <li class="menu-title">Menu</li>

        <li>
            <a href="/" class="side-nav-link-ref">
                <i class="bx bx-home-circle"></i>
                <span>Inicio</span>
            </a>
        </li>
        <li v-if="puedeVerAnalisis">
            <a href="/web/analisis/panel" class="side-nav-link-ref">
                <i class="bx bx-analyse"></i>
                <span>Análisis</span>
            </a>
        </li>
        <li v-if="puedeVerAnalisis">
            <a href="/web/analisis/simulador" class="side-nav-link-ref">
                <i class="bx bx-line-chart"></i>
                <span>Simulador</span>
            </a>
        </li>
        <li v-if="puedeVerMetricasHubSpot">
            <a href="/web/dashboard/advance" class="side-nav-link-ref">
                <i class="bx bx-bar-chart-alt-2"></i>
                <span>Métricas HubSpot</span>
            </a>
        </li>
        <li v-if="isAdmin">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-bullseye"></i>
                <span>Scoring</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li>
                    <a href="/web/dashboard/leadscoring" class="side-nav-link-ref">Advance/Postgrado</a>
                </li>
                <li>
                    <a href="/web/dashboard/leadscoringpregrado" class="side-nav-link-ref">Ranking de participación</a>
                </li>
            </ul>
        </li>
        <li v-if="puedeVerArancelesHubSpot">
            <a href="/web/configuracion/aranceles" class="side-nav-link-ref">
                <i class="bx bx-dollar-circle"></i>
                <span>Aranceles HubSpot</span>
            </a>
        </li>
        <li v-if="puedeVerProyeccion">
            <a href="/web/dashboard/proyeccion" class="side-nav-link-ref">
                <i class="mdi mdi-chart-timeline-variant"></i>
                <span>Proyección de matrículas</span>
            </a>
        </li>
        <li v-if="puedeVerProyeccion">
            <a href="/web/dashboard/proyeccionleads" class="side-nav-link-ref">
                <i class="bx bx-target-lock"></i>
                <span>Proyección de leads</span>
            </a>
        </li>
        <li v-if="puedeVerDashboardAdmision">
            <a href="/web/dashboard/admision" class="side-nav-link-ref">
                <i class="bx bx-trending-up"></i>
                <span>Dashboard Admisión</span>
            </a>
        </li>
        <li v-if="puedeVerViaAdmision">
            <a href="/web/dashboard/viaadmision" class="side-nav-link-ref">
                <i class="bx bx-git-branch"></i>
                <span>Vía de admisión</span>
            </a>
        </li>
        <li v-if="puedeVerCertificadoTitulo">
            <a href="/web/configuracion/certificadotitulo" class="side-nav-link-ref">
                <i class="bx bx-award"></i>
                <span>Certificado de título</span>
            </a>
        </li>
        <li v-if="isStaff || esUsuarioPermisoEspecialLaborantes">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-group"></i>
                <span>Usuarios</span>
            </a>
            <ul class="sub-menu" aria-expanded="true">
                <li v-if="isStaff">
                    <a href="/web/configuracion/usuarios" class="side-nav-link-ref">Ver Usuarios</a>
                </li>
                <li>
                    <a href="/web/configuracion/laborantes" class="side-nav-link-ref">Ver Laborantes</a>
                </li>
                <li v-if="isStaff">
                    <a href="/web/configuracion/crearusuario" class="side-nav-link-ref">Agregar Usuario</a>
                </li>
                <li v-else-if="esUsuarioPermisoEspecialLaborantes">
                    <a href="/web/configuracion/crearusuario" class="side-nav-link-ref" @click.prevent="crear('Laborante')">Agregar Laborante</a>
                </li>
                <!-- Usuarios Reemplazo oculto -->
            </ul>
        </li>
        <!-- <li v-if="user.rol=='Admin'">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-share-alt"></i>
                <span>Usuarios</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li>
                    <a href="/web/configuracion/usuarios">Ver Usuarios</a>
                </li>
                <li>
                    <a href="/web/configuracion/laborantes">Ver Laborantes</a>
                </li>
                <li>
                    <a href="/web/configuracion/crearusuario">Agregar Usuario</a>
                </li>
            </ul>
        </li> -->
        <li v-if="puedeVerColegios">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-buildings"></i>
                <span>Colegios</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li>
                    <a href="/web/configuracion/colegios" class="side-nav-link-ref">Buscar Colegio</a>
                </li>
                <li v-if="puedeCrearColegios">
                    <a href="/web/configuracion/crearcolegio" class="side-nav-link-ref">Crear Colegio</a>
                </li>
            </ul>
        </li>
        <li v-if="puedeVerEventos">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-calendar-event"></i>
                <span>Eventos</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li>
                    <a href="/web/configuracion/eventos" class="side-nav-link-ref">Buscar Eventos</a>
                </li>
                <li v-if="puedeCrearEventos">
                    <a href="/web/configuracion/crearevento" class="side-nav-link-ref">Crear Evento</a>
                </li>
            </ul>
        </li>
        <li v-if="puedeVerLaborantes">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-user-check"></i>
                <span>Laborantes</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li>
                    <a href="/web/laborantes/agregarapoyo" class="side-nav-link-ref">Agregar laborante apoyo oficina</a>
                </li>
                <li>
                    <a href="/web/laborantes/agregarsalida" class="side-nav-link-ref">Agregar laborante salida por actividades</a>
                </li>
                <li>
                    <a href="/web/laborantes/apago" class="side-nav-link-ref">Listado Pago Laborantes</a>
                </li>
                <li v-if="puedeVerPagosLaborantes">
                    <a href="/web/laborantes/pagos" class="side-nav-link-ref">Pagos Laborantes</a>
                </li>
                <li v-if="puedeVerPagosLaborantes">
                    <a href="/web/laborantes/porpagar" class="side-nav-link-ref">Por Pagar</a>
                </li>
                <li v-if="puedeVerPagosLaborantes">
                    <a href="/web/laborantes/todospagos" class="side-nav-link-ref">Historial de pagos</a>
                </li>
                <li v-if="isAdmin">
                    <a href="/web/laborantes/valorespago" class="side-nav-link-ref">Valores Pagos</a>
                </li>
            </ul>
        </li>
        <li v-if="puedeVerGastos">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-receipt"></i>
                <span>Gastos asociados</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li>
                    <a href="/web/gastos/ver" class="side-nav-link-ref">Revisión Gastos</a>
                </li>
                <li>
                    <a href="/web/gastos/historial" class="side-nav-link-ref">Historial de Gastos</a>
                </li>
            </ul>
        </li>
        <li v-if="isAdmin || user.rol === 'Coordinador' || esDigitalizadorSoloHistorial">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-camera"></i>
                <span>Digitalizador</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li v-if="!esDigitalizadorSoloHistorial">
                    <a href="/web/digitalizar/asociar" class="side-nav-link-ref">Digitalizador</a>
                </li>
                <li>
                    <a href="/web/digitalizar/historial" class="side-nav-link-ref">Historial</a>
                </li>
                <li v-if="isAdmin">
                    <a href="/web/digitalizar/estadisticas" class="side-nav-link-ref">Estad&iacute;sticas</a>
                </li>
            </ul>
        </li>
        <li v-if="user.rol === 'SuperAdmin'">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-bar-chart-alt-2"></i>
                <span>Evaluaciones</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li v-if="isAdmin || user.cargo=='Supervisor'">
                    <a href="/web/evaluar/coordinador" class="side-nav-link-ref">Evaluar Coordinador</a>
                </li>
                <li>
                    <a href="/web/evaluar/laborante" class="side-nav-link-ref">Evaluar Laborante</a>
                </li>
                <li>
                    <a href="/web/evaluaciones/coordinadores" class="side-nav-link-ref">Evaluaciones Coordinadores</a>
                </li>
                <li>
                    <a href="/web/evaluaciones/laborantes" class="side-nav-link-ref">Evaluaciones Laborantes</a>
                </li>
            </ul>
        </li>
        <!-- <li v-if="user.rol=='Admin' && user.rol!='Laborante'">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-share-alt"></i>
                <span>Configuración</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li>
                    <a href="/web/actualizacion/usuarioscolegios">Actualizar usuarios-colegios</a>
                </li>
                <li>
                    <a href="/web/actualizacion/colegios">Actualizar colegios</a>
                </li>
            </ul>
        </li> -->
        <!-- <li>
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-share-alt"></i>
                <span>Multi Level</span>
            </a>
            <ul class="sub-menu" aria-expanded="true">
                <li>
                    <a href="javascript: void(0);">Level 1.1</a>
                </li>
                <li>
                    <a href="javascript: void(0);" class="has-arrow">Level 1.2</a>
                    <ul class="sub-menu" aria-expanded="true">
                        <li>
                            <a href="javascript: void(0);">Level 2.1</a>
                        </li>
                        <li>
                            <a href="javascript: void(0);">Level 2.2</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </li> -->
    </ul>
</div>
<!-- Sidebar -->
</template>

<style>
#sidebar-menu .sub-menu li a.active,
#sidebar-menu .sub-menu li a.side-nav-link-ref.active,
#sidebar-menu li a.side-nav-link-ref.active {
    color: #CB9700 !important;
}
#sidebar-menu .sub-menu li.mm-active > a,
#sidebar-menu ul li.mm-active > a {
    color: #CB9700 !important;
}
</style>
